import React from "react";
import { COLORS } from "../theme/colors";

// MNT-014: shared tab button used by the Bind{Channel,Workflow,Integration}
// wiring modals. Extracted verbatim from the three identical copies.
function TabBtn({ active, onClick, label }) {
  return (
    <button type="button" onClick={onClick} style={{
      flex: 1, padding: "10px 14px", border: "none",
      background: active ? COLORS.surface : "transparent",
      borderBottom: `2px solid ${active ? COLORS.accent : "transparent"}`,
      color: active ? COLORS.text : COLORS.textMuted,
      fontSize: 12, fontWeight: 600, cursor: "pointer",
      transition: "color 0.15s, border-color 0.15s",
    }}>
      {label}
    </button>
  );
}

export default TabBtn;
